import type { IAppearanceOption, IAppearanceSettingsForm } from '@/types/composables/useAppearance';
import type { EAppearanceField } from '@/types/composables/useAppearance.enums';
import type { DarkMode, IDetailsResponse, SelectedColor } from '@/types/services/user.service';

const enabledThemesEnv = import.meta.env.VITE_FEATURE_FLAG_ENABLED_THEMES ?? 'blue,red,purple';
export const enabledThemesNames = enabledThemesEnv
  .split(',')
  .map<SelectedColor>((theme) => theme.trim() as SelectedColor);

export const getEnabledThemesObjects = (t: (key: string) => string) =>
  (
    [
      {
        label: t('settings.appearance.color.options.blue'),
        value: 'blue',
        color: '#0651DE'
      },
      {
        label: t('settings.appearance.color.options.red'),
        value: 'red',
        color: '#DE0606'
      },
      {
        label: t('settings.appearance.color.options.purple'),
        value: 'purple',
        color: '#990AE3'
      }
      // {
      //   label: t('settings.appearance.color.options.wineRed'),
      //   value: 'wine-red',
      //   color: '#42080E'
      // }
    ] satisfies IAppearanceOption<IAppearanceSettingsForm[EAppearanceField.SELECTED_COLOR]>[]
  ).filter((option) => enabledThemesNames.includes(option.value));

export const getThemeMode = (uiMeta?: IDetailsResponse['meta']['ui']): DarkMode => {
  const prefersDark =
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  return uiMeta?.useBrowserDark ? (prefersDark ? 'dark' : 'light') : (uiMeta?.theme ?? 'light');
};
